import { useState } from "react";
import styles from "./consultBox.module.scss";
import ConsultPopup from "./ConsultPopup";

export default function ConsultBox({ setShowForm }) {

  return (
    <>
      <div className={styles["sapo-register-cta"]}>
        <div className={styles["title"]}>
          <img
            src={process.env.NEXT_PUBLIC_BASE_PATH + "/images/icon-omni-article.png"}
            alt="Chứng nhận Bộ Công Thương"
          />
          <h2>+230.000 khách hàng đã lựa chọn Sapo</h2>
        </div>
        <div className={styles["list-content"]}>
          <div className={styles["item"]}>
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 13 10" fill="none">
              <path d="M4.97803 9.80759C4.85396 9.93113 4.68468 10.0003 4.50885 10.0003C4.33302 10.0003 4.16374 9.93144 4.03966 9.80759L0.291799 6.09407C-0.0972662 5.70864 -0.0972662 5.08385 0.291799 4.69934L0.760983 4.23423C1.15005 3.84879 1.7801 3.84879 2.16885 4.23423L4.50854 6.55239L10.8312 0.289076C11.2202 -0.0963587 11.8509 -0.0963587 12.239 0.289076L12.7082 0.754193C13.0973 1.13963 13.0973 1.76411 12.7082 2.14892L4.97772 9.8079L4.97803 9.80759Z" fill="#007AFF" />
            </svg>
            Bán hàng hợp kênh
          </div>
          <div className={styles["item"]}>
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 13 10" fill="none">
              <path d="M4.97803 9.80759C4.85396 9.93113 4.68468 10.0003 4.50885 10.0003C4.33302 10.0003 4.16374 9.93144 4.03966 9.80759L0.291799 6.09407C-0.0972662 5.70864 -0.0972662 5.08385 0.291799 4.69934L0.760983 4.23423C1.15005 3.84879 1.7801 3.84879 2.16885 4.23423L4.50854 6.55239L10.8312 0.289076C11.2202 -0.0963587 11.8509 -0.0963587 12.239 0.289076L12.7082 0.754193C13.0973 1.13963 13.0973 1.76411 12.7082 2.14892L4.97772 9.8079L4.97803 9.80759Z" fill="#007AFF" />
            </svg>
            Quản lý tập trung
          </div>
          <div className={styles["item"]}>
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 13 10" fill="none">
              <path d="M4.97803 9.80759C4.85396 9.93113 4.68468 10.0003 4.50885 10.0003C4.33302 10.0003 4.16374 9.93144 4.03966 9.80759L0.291799 6.09407C-0.0972662 5.70864 -0.0972662 5.08385 0.291799 4.69934L0.760983 4.23423C1.15005 3.84879 1.7801 3.84879 2.16885 4.23423L4.50854 6.55239L10.8312 0.289076C11.2202 -0.0963587 11.8509 -0.0963587 12.239 0.289076L12.7082 0.754193C13.0973 1.13963 13.0973 1.76411 12.7082 2.14892L4.97772 9.8079L4.97803 9.80759Z" fill="#007AFF" />
            </svg>
            Tiết kiệm thời gian & chi phí
          </div>
        </div>
        <button onClick={() => setShowForm(true)} className="btn-registration">
          Đăng ký ngay
        </button>
      </div>

    </>
  );
}
